import menuOperation from './menu-operation'
import notice from './notice'
import vendorManagement from './vendor-management'
import user from './user'


export default {
    menuOperation,
    notice,
    vendorManagement,
    user
}